module.exports = __webpack_public_path__ + "9628e17c77a473228696cfbfa02848f3.svg";